import Marquee from "react-fast-marquee";

const WORDS = [
  "Bringing India's Past Back to Life",
  "Reimagining Heritage",
  "ReplayEra",
  "For a Viksit Bharat",
];

export default function EditorialMarquee() {
  return (
    <section
      data-testid="marquee-section"
      className="relative border-y border-gold/10 py-16 md:py-24 overflow-hidden bg-obsidian"
    >
      <Marquee
        speed={38}
        gradient={false}
        pauseOnHover
        className="py-2"
      >
        {[...WORDS, ...WORDS].map((w, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-display italic text-[7rem] md:text-[13rem] leading-none px-10 ${
                i % 2 === 0 ? "text-bone" : "text-outline"
              }`}
            >
              {w}
            </span>
            <span className="text-gold text-6xl md:text-8xl px-2">·</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
